import { trace } from 'rytm-helpers'
import Pizzicato from 'pizzicato'
import { gsap, TweenLite, TimelineMax, TweenMax, Elastic, Expo, Sine, Back, Power1, Power2, Power3, Power4 } from 'gsap'

class Sound {
  /**
  * Sound class constructor  
  * @constructor
  * @param {String} file - file name with extension  
  * @param {String} path - file path  
  **/
  constructor(filename, path) {
    this.id = filename.split('.').slice(0, -1).join('.')
    this.filename = filename
    this.path = path
    this.pitch = 1
    this.pz = null
  }
  /**
   * Play sound
   */
  play(params) {
    this.pitch = params.pitch ? params.pitch : 1
    this.pan = params.pan ? params.pan : 0
    // trace("play sound", this.id)
    if (this.pz) {
      this.pz.play()
      this.onPlaybackStarted()
    } else {
      // create pizzicato sound
      this.pz = new Pizzicato.Sound(this.path, () => {
        this.pz.play()
        this.onPlaybackStarted()
      })
      // setup attack
      this.pz.attack = .01
      this.pz.release = 1
      // setup pan
      if (this.pan != 0) {
        const stereoPan = new Pizzicato.Effects.StereoPanner({pan: this.pan})
        this.pz.addEffect(stereoPan)
      }
      // add efx
      // const delay = new Pizzicato.Effects.Delay({
      //   feedback: .4,
      //   time: .2,
      //   mix: .1
      // })
      // this.pz.addEffect(delay)
      const reverb = new Pizzicato.Effects.Reverb({
        time: 1,
        decay: .3,
        // reverse: true,
        mix: 0.2
      });
      this.pz.addEffect(reverb);
    }
  }
  onPlaybackStarted() {
    // this.pz.sourceNode.playbackRate.value = this.pitch
    if (this.pitch != 1) {
      TweenMax.set(this.pz.sourceNode.playbackRate, {value: 1})
      TweenMax.to(this.pz.sourceNode.playbackRate, .4, {value: this.pitch})
    }
  }
  /**
   * Stop sound
   */
  stop() {
    if (this.pz) {
      this.pz.stop()
    }
  }
  /**
   * Destroy sound
   */
  destroy() {
    if (this.pz) {
      this.pz.stop()
      this.pz = null
    }
  }
  /**
   * Get sequence random time
   */
  getSequenceRandomTime() {
    const idLen = this.id.length
    const min = 50 * idLen
    const max = 150 * idLen
    return Math.random() * (max - min) + min
  }

  /**
   * ### PRIVATE METHODS ###
   */
  

}

export default Sound;
